import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormModule } from '@woolworthsnz/form';
import { ProductModule } from '@woolworthsnz/product';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import {
	ArticleComponent,
	Carousel2DCComponent,
	DynamicContentComponent,
	FormCheckboxComponent,
	FormDropdownComponent,
	FormEmailComponent,
	FormHiddenComponent,
	FormMultilineComponent,
	FormNumberComponent,
	FormSingleLineComponent,
	FormSubmitComponent,
	HtmlComponent,
	ImageComponent,
	ImageNavigationComponent,
	ProductGridComponent,
} from './components';
import { BannerItemComponent } from './components/banner-item/banner-item.component';
import { BannerComponent } from './components/banner/banner.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { InlineSvgComponent } from './components/inline-svg/inline-svg.component';
import { ServiceBarItemComponent } from './components/service-bar-item/service-bar-item.component';
import { ServiceBarComponent } from './components/service-bar/service-bar.component';
import { TextComponent } from './components/text/text.component';
import { DynamicComponentDirective } from './directives';
import { TargetTranslatePipe } from './pipes';
import { SearchLibModule } from '@woolworthsnz/search';
import { RecipeModule } from '@woolworthsnz/recipe';

const components = [
	BannerComponent,
	BannerItemComponent,
	DynamicContentComponent,
	FormEmailComponent,
	HtmlComponent,
	ImageComponent,
	CarouselComponent,
	Carousel2DCComponent,
	ServiceBarComponent,
	ServiceBarItemComponent,
	ImageNavigationComponent,
	InlineSvgComponent,
	ArticleComponent,
	FormNumberComponent,
	FormSubmitComponent,
	FormDropdownComponent,
	FormCheckboxComponent,
	FormMultilineComponent,
	FormSingleLineComponent,
	FormHiddenComponent,
	ProductGridComponent,
	TextComponent,
];

const directives = [DynamicComponentDirective];

const pipes = [TargetTranslatePipe];

@NgModule({
	exports: [...components, ...directives, ...pipes],
	imports: [
		CommonModule,
		ProductModule,
		RecipeModule,
		RouterModule,
		StyleguideModule,
		FormModule,
		FormsModule,
		ReactiveFormsModule,
		SearchLibModule,
		...components,
		...directives,
		...pipes,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DynamicContentModule {}
